import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { LoadingSpinner } from '@sharpe/ui/components';
import { useCurrentUser } from '@/hooks/use-current-user-org';

function AuthLoading() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <LoadingSpinner size="3xl" variant="sand" className="text-muted-foreground" />
    </div>
  );
}

export function RequireAuth({ children }: { children: ReactNode }) {
  const { isAuthenticated, sessionStatus } = useCurrentUser();
  const location = useLocation();

  if (sessionStatus === 'loading') {
    return <AuthLoading />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth/signin" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}

export function RequireOrgAdmin({ children }: { children: ReactNode }) {
  const { isAuthenticated, isOrgAdmin, sessionStatus } = useCurrentUser();
  const location = useLocation();

  if (sessionStatus === 'loading') {
    return <AuthLoading />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth/signin" replace state={{ from: location.pathname }} />;
  }

  if (!isOrgAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
